import { createReducer } from '@src/redux/helpers/createReducer';
import { RETRIEVE_DRAFT } from './constants';

const initialState = {
  tinStatus: {},
  tinSubmission: {},
  uploadedDocument: {},
  documentIds: {},
  isDocumentUploading: {
    'address.primaryServicingProof': false,
    'address.primaryBillingProof': false,
    'address.primaryRemittanceProof': false,
    'address.secondaryServicing[0].proof': false,
    'address.secondaryServicing[1].proof': false,
    'address.secondaryServicing[2].proof': false,
    'address.secondaryServicing[3].proof': false,
    'address.secondaryServicing[4].proof': false,
  },
  trackingNumber: '',
  signatureCanvas: '',
  retrieveDraftSaga: { isError: false, isLoading: false, isSuccess: false },
};

export const tinReducer = createReducer(initialState, {
  [`${RETRIEVE_DRAFT}_SUCCESS`]: (state, action) => {
    return {
      ...state,
      tinDraft: { ...action.payload },
      retrieveDraftSaga: { isError: false, isLoading: false, isSuccess: true },
    };
  },
  [`${RETRIEVE_DRAFT}_ERROR`]: (state, action) => {
    return {
      ...state,
      tinDraft: {},
      retrieveDraftSaga: { isError: true, isLoading: false, isSuccess: false },
    };
  },
  [`${RETRIEVE_DRAFT}_STARTED`]: (state, action) => {
    return {
      ...state,
      tinDraft: {},
      retrieveDraftSaga: { isError: false, isLoading: true, isSuccess: false },
    };
  },
});
